import { BrowserRouter, Route, Routes } from "react-router-dom";
import { WhatsAppFab } from "./components/WhatsAppFab.jsx";
import { HomePage } from "./pages/HomePage.jsx";
import { ApplyPage } from "./pages/ApplyPage.jsx";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/apply" element={<ApplyPage />} />
      </Routes>
      <WhatsAppFab />
    </BrowserRouter>
  );
}
